const OffersRoutes = {
  createOffer: "/promoOffer/createPromo",
  getAllOffers: "/promoOffer/getAllPromos",
  updateOffer: "/promoOffer/updateStatus",
  deleteOffer: "/promoOffer/delete"
}

export default OffersRoutes;